import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopProductList from '../../../components/Shops/Products'


const ShopProductPage = (): ReactElement => {
  return (
    <Layout >
      <ShopProductList />
    </Layout>
  )
}

export default ShopProductPage
